module.exports = __webpack_public_path__ + "img/2473.a43f27da.gif";